export const formatDateUS = (
  dateString: string | Date | undefined | null,
  withTime: boolean = false,
): string => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  const month = String(date.getMonth() + 1).padStart(2, "0"); // 0-indexed
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  const baseDate = `${month}/${day}/${year}`;

  if (withTime) {
    const hours = date.getHours() % 12 || 12;
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${baseDate} ${hours}:${minutes} ${ampm}`;
  }

  return baseDate;
};
